/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Button, Modal } from 'react-bootstrap';

const ApplicationModal = ({ logoutModal, logoutConfirmation, logoutSession, sessionTimeoutModal, handleSessionTimeoutModal }) => {
    return (<>
        <Modal show={logoutModal} onHide={logoutConfirmation}>
            <Modal.Header closeButton>
                <Modal.Title>Logout Confirmation</Modal.Title>
            </Modal.Header>
            <Modal.Body>Are you sure you want to logout?</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={logoutConfirmation}>
                    Cancel
                </Button>
                <a className="btn theme-bg-color" onClick={() => logoutSession(false)}>
                    Confirm
                </a>

            </Modal.Footer>
        </Modal>

        <Modal show={sessionTimeoutModal} onHide={handleSessionTimeoutModal}>
            <Modal.Header>
                <Modal.Title>Session Timeout</Modal.Title>
            </Modal.Header>
            <Modal.Body>Your session has been expired. Please proceed to login</Modal.Body>
            <Modal.Footer>
                <a href="/depositapp" target="_self" className="btn theme-bg-color" onClick={() => logoutSession(false)}>
                    Confirm
                </a>

            </Modal.Footer>
        </Modal>
    </>);
}

export default ApplicationModal;